import axios from 'axios'


export default {
    name: 'customerCreditAPI',
    getAccount(session) {
        return axios.get('/api/v1/customercredit?session=' + session)
    },
    getAccountByEmail(email) {
        return axios.get('/api/v1/customercredit/getaccountbyemail?email=' + email)
    },
}